import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '@app/services/authentication.service';
import { VisualizernewService } from '@app/services/visualizernew.service';
import { UserIdleService } from 'angular-user-idle';
import { of, throwError } from 'rxjs';
import { catchError, delay, finalize, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IAuth } from '@app/auth-module/interfaces/auth.interface';
import { IntegrationResponse } from '@interfaces';

@Component({
  standalone: false,
  selector: 'app-component-o-auth-login',
  templateUrl: './component-o-auth-login.component.html',
  styleUrls: ['./component-o-auth-login.component.css']
})
export class ComponentOAuthLoginComponent implements OnInit {
  public form: FormGroup;
  public forgotPassword: boolean;
  public year = new Date().getFullYear();
  public title: string;
  public organizationName: string;
  public isLoading = false;
  public error: string = null;
  public companyId: string;
  public marketPlaceUrl: string;
  public marketPlaceName: string;
  public code: string;
  public background1 = false; 
  public background2 = true;
  public marketPlaceRedirectUrl: string;

  constructor(
    private _authentication: AuthenticationService,
    private _vservice: VisualizernewService,
    private _userIdle: UserIdleService,
    private _router: Router,
    private _formBuilder: FormBuilder,
    private _route: ActivatedRoute
  ) {
    this.form = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      rememberMe: [false],
    });
    this.marketPlaceName = this._route.snapshot.params.mplName;

  }

  get emailControl() {
    return this.form.get('email');
  }

  get passwordControl() {
    return this.form.get('password');
  }

  @HostListener('window:mousemove') refreshUserState() {
    this.restart();
  }

  ngOnInit() {
    this.title = environment.title;
    this.forgotPassword = environment.accessConfig.forgotPassword;
    this.organizationName = environment.organization;
    this._userIdle.startWatching();
    this._userIdle.onTimerStart().subscribe(() => { });
    this._userIdle.onTimeout().subscribe(() => {
      this._authentication.logout();
      this._router.navigate(['/login']);
    });

    // Get companyId from query parameters
    this._route.queryParams
      .pipe(
        switchMap(params => {
          this.companyId = params['companyId'];
          this.marketPlaceRedirectUrl = params['redirect']
          sessionStorage.setItem('redirect', params['redirect'])
          // console.log(this.marketPlaceName + "//  next  //"+this.companyId);
          // this.marketPlaceName = this.marketPlaceName ? this.marketPlaceName : "smart-recruiters" ;
          if (this.companyId) {
            return this._authentication.integration(this.marketPlaceName, this.companyId)
              .pipe(
                catchError((error) => {
                  this.error = 'Failed to fetch company data. Please try again later.';
                  return throwError(error);
                })
              );
          } else {
            console.log("companyId get on null");
            return of(null);
          }
        })
      )
      .subscribe((data: IntegrationResponse) => {
        if (data) {
          this.marketPlaceUrl = data.market_place_url;
          this.code = data.code;
          this.companyId = data.company_id;
        }
      });
  }

  restart(): void {
    this._userIdle.resetTimer();
  }

  authorize(): void {
    if (this.form.invalid) {
      return;
    }

    this.isLoading = true;
    const form: IAuth = this.form.value;

    this._authentication.o_auth(form.email, form.password, this.companyId, this.code, this.marketPlaceUrl, this.marketPlaceName)
      .pipe(
        switchMap((authResult) => {
          const result = authResult.result? authResult.result : authResult;
          sessionStorage.setItem('authResult', JSON.stringify(result))
          this._router.navigate([`marketplace/integration/confirm`,this.companyId])
          return this._vservice.someMethod(authResult);
        }),
        catchError((error) => {
          if (error.status === 404) {
            this.error = 'Username or Password is incorrect';
          } else {
            this.error = "internal server error";
          }
          return throwError(error).pipe(delay(3000), tap(() => this.error = null));
        }),
        finalize(() => this.isLoading = false)
      )
      .subscribe();
  }
}